import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "../styles/confirmModal.css";

export default function InfoModal({ show, title, message, onClose, onContinue }) {

  return (
    <Modal animation={false} show={show} centered backdrop="static" data-testid="info-modal">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <div aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <div>{message}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} className="cancel-update-subs">
          Close
        </Button>
        {onContinue && (
          <Button variant="primary" className="continue-update-subs" onClick={onContinue}>
            Continue
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
